import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from "./Button";
import { backIcon } from "../utils/icons";

class AccountEdit extends Component {
  componentDidMount() {
    this.handleEditProfile = ({ detail }) => {
      this.props.history.push(`/konto/${detail.id}`);
    };

    document.addEventListener("edit-profile", this.handleEditProfile);
  }

  componentWillUnmount() {
    document.removeEventListener("edit-profile", this.handleEditProfile);
  }

  render() {
    const { app, oidc } = this.props;

    const userProps = {
      user: oidc.user.profile,
      token: oidc.user.access_token,
      baseUrl: app.aswApi,
      identityUrl: app?.serverIdentity.authority,
      loadingBlockerContainerHeight: "100%",
    };

    return (
      <section style={{ paddingInline: "15px" }}>
        <div style={{ marginLeft: "1.2rem" }}>
          <Button type="button" onClick={() => this.props.history.goBack()}>
            <span style={{ display: "flex", alignItems: "center" }}>
              <i style={{ marginRight: "5px" }} className={backIcon}></i>
              Powrót
            </span>
          </Button>
        </div>
        <account-edit props-json={JSON.stringify(userProps)}></account-edit>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    app: state.app,
    user: state.user,
    oidc: state.oidc,
  };
};

export default withRouter(connect(mapStateToProps)(AccountEdit));
